import React, { FC } from 'react';
import { Card, Note } from 'components/ui';
import { Field } from 'react-final-form';
import { TextInputWrapper } from 'components/forms';
import { t } from 'utils';
import styles from './Form.module.scss';

const MonthlyFee: FC = () => {
  return (
    <Card title='form.step.app.monthly.fee.title'>
      <div className={styles.formRow}>
        <Field
          name='fee_eur'
          label='Fee in EUR'
          component={TextInputWrapper}
          className='mr-2'
          required
        />
        <Field name='fee_gbp' label='Fee in GBP' component={TextInputWrapper} required />
      </div>
      <Note>{t('form.step.app.monthly.fee.note')}</Note>
    </Card>
  );
};

export default MonthlyFee;
